import styled from "styled-components";
import { media } from "../../theme/theme";

export const Step3Spacing = styled.div`
    ${media.tablet} {
        padding-top: 155px;
    }

    ${media.custom(1140)} {
        padding-top: 205px;
    }
`;

export const TrailSVGStep3 = styled.img`
    width: 166px;
    display: block;
    margin: 0 auto 45px;

    ${media.tablet} {
        margin: initial;
        position: absolute;
        width: 100px;
        height: auto;
        left: calc(50% - 35px);
        transform: translate(-50%, -50%);
        top: calc(0% - 75px);
    }

    ${media.custom(1140)} {
        width: 166px;
    }
`;